import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Nav, TabContent, TabPane } from 'reactstrap';
import { KanbanProvider } from 'hooks/useKanban';
import { Kanban } from 'libs/kanban';
import { NavItemStyles } from '../Tab-Pane-Media/styles';
import TabPanePhases from '../Tab-Pane-Phases';
import TabPaneFocuses from './Tab-Pane-Focuses';
import TabPaneActivities from './Tab-Pane-Activities';
import TabPaneEctoStatus from './Tab-Pane-Ecto-Status';
import TabPaneClientStatus from './Tab-Pane-Client-Status';
import TabPaneAreas from './Tab-Pane-Areas';

const TabPaneSEO = ({ setStatus }) => {
  const { t: translate } = useTranslation();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const accountParam = searchParams.get('id');
  const seo = new Kanban('seo', accountParam);
  const [activeNav, setActiveNav] = useState('1');
  const [columns, setColumns] = useState([]);
  const [focuses, setFocuses] = useState([]);
  const [activities, setActivities] = useState([]);
  const [ectoStatus, setEctoStatus] = useState([]);
  const [clientStatus, setClientStatus] = useState([]);
  const [areas, setAreas] = useState([]);

  const fetchAccountInfo = async () => {
    const columns = await seo.getColumns();
    const types = await seo.getTypes();

    return { columns, types };
  };

  useEffect(() => {
    const accountInfo = fetchAccountInfo();
    accountInfo.then((data) => {
      if (data && data.columns) {
        const columnsArray = Object.values(data.columns).sort((a, b) => a.position - b.position);
        setColumns(columnsArray);
      } else {
        setColumns([]);
      }

      if (data && data.types.focuses) {
        const focusesArray = Object.values(data.types.focuses);
        setFocuses(focusesArray);
      } else {
        setFocuses([]);
      }

      if (data && data.types.activities) {
        const activitiesArray = Object.values(data.types.activities);
        setActivities(activitiesArray);
      } else {
        setActivities([]);
      }

      if (data && data.types['ecto-status']) {
        const ectoStatusArray = Object.values(data.types['ecto-status']);
        setEctoStatus(ectoStatusArray);
      } else {
        setEctoStatus([]);
      }

      if (data && data.types['client-status']) {
        const clientStatusArray = Object.values(data.types['client-status']);
        setClientStatus(clientStatusArray);
      } else {
        setClientStatus([]);
      }

      if (data && data.types.areas) {
        const areasArray = Object.values(data.types.areas);
        setAreas(areasArray);
      } else {
        setAreas([]);
      }
    });
  }, [accountParam]);

  return (
    <div className="" style={{ display: 'flex', gap: '4.25rem' }}>
      <Nav vertical>
        <NavItemStyles active={activeNav === '1'}>
          <div onClick={() => setActiveNav('1')}>{translate('Activities')}</div>
        </NavItemStyles>
        <NavItemStyles active={activeNav === '2'}>
          <div onClick={() => setActiveNav('2')}>{translate('Focuses')}</div>
        </NavItemStyles>
        <NavItemStyles active={activeNav === '3'}>
          <div onClick={() => setActiveNav('3')}>Status Ecto</div>
        </NavItemStyles>
        <NavItemStyles active={activeNav === '4'}>
          <div onClick={() => setActiveNav('4')}>Status {translate('Client')}</div>
        </NavItemStyles>
        <NavItemStyles active={activeNav === '5'}>
          <div onClick={() => setActiveNav('5')}>{translate('Areas')}</div>
        </NavItemStyles>
        <NavItemStyles active={activeNav === '6'}>
          <div onClick={() => setActiveNav('6')}>{translate('Phases')}</div>
        </NavItemStyles>
      </Nav>
      <KanbanProvider kanbanName="seo" accountId={accountParam}>
        <TabContent activeTab={activeNav}>
          <TabPane tabId="1">
            <TabPaneActivities
              setStatus={setStatus}
              activities={activities}
              setActivities={setActivities}
            />
          </TabPane>
          <TabPane tabId="2">
            <TabPaneFocuses setStatus={setStatus} focuses={focuses} setFocuses={setFocuses} />
          </TabPane>
          <TabPane tabId="3">
            <TabPaneEctoStatus
              setStatus={setStatus}
              ectoStatus={ectoStatus}
              setEctoStatus={setEctoStatus}
            />
          </TabPane>
          <TabPane tabId="4">
            <TabPaneClientStatus
              setStatus={setStatus}
              clientStatus={clientStatus}
              setClientStatus={setClientStatus}
            />
          </TabPane>
          <TabPane tabId="5">
            <TabPaneAreas setStatus={setStatus} areas={areas} setAreas={setAreas} />
          </TabPane>
          <TabPane tabId="6">
            <TabPanePhases
              setStatus={setStatus}
              columns={columns}
              setColumns={setColumns}
              kanbanName="seo"
            />
          </TabPane>
        </TabContent>
      </KanbanProvider>
    </div>
  );
};

TabPaneSEO.propTypes = {
  setStatus: PropTypes.func.isRequired,
};

export default TabPaneSEO;
